// extracted by mini-css-extract-plugin
module.exports = {"gallery":"styles-module--gallery--3WWHH","container":"styles-module--container--216SO","element":"styles-module--element--6rsUy"};